import {NgModule} from '@angular/core';
import {Routes, RouterModule} from '@angular/router';
import {ResourceComponent} from './resource.component';
import {ResourceResolver} from '../resolvers/resource-resolver';
import {PspdfkitViewComponent} from './pspdfkit-view.component';

const routes: Routes = [
  {
    path: '',
    component: PspdfkitViewComponent,
    children: [

      {
        path: ':pspdfkitId',
        component: ResourceComponent,
        resolve: {
          resource: ResourceResolver
        }
      },
      /*,
      {
        path: 'resource',
        children: [{
          path: ':pspdfkitId',
          component: ResourceComponent,
          resolve: {
            resource: ResourceResolver
          }
        }]
      },*/

      /*
      {
        path: 'segment/:pspdfkitId',
        component: ResourceComponent,
        resolve: {
          resource: SegmentDocumentResolver
        }
      },

      {
        path: 'MY_DOCUMENTS/document/:userDocumentId',
        component: UserDocumentComponent,
        resolve: {
          userDocument: UserDocumentResolver
        }
      },
      */
      /*
      {
        path: 'resource/:code/:pspdfkitId',
        component: ResourceComponent,
        resolve: {
          resource: ResourceResolver
        }
      },
      {
        path: '**',
        component: PageNotFoundComponent
      }*/
    ]
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class PspdfkitRoutingModule {
}
